import { IButtonProps, PrimaryButton as FabricPrimaryButton, Spinner } from "@fluentui/react";
import React, { useEffect, useState } from "react";

export interface LoaderButtonProps extends Pick<IButtonProps, "text" | "disabled" | "type" | "onClick" | "styles"> {
    isLoading: boolean;
    testId?: string;
}

export const LoadingButton: React.FunctionComponent<LoaderButtonProps> = (props: LoaderButtonProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(props.isLoading);

    useEffect(() => {
        setIsLoading(props.isLoading);
    }, [props.isLoading]);

    return (
        <FabricPrimaryButton
            {...props}
            disabled={isLoading || props.disabled}
            text={isLoading ? undefined : props.text}
            data-testId={props.testId}
        >
            {!props.disabled && isLoading ? <Spinner hidden={false} /> : props.text}
        </FabricPrimaryButton>
    );
};
